import { GraphQLClient } from 'graphql-request';
import { Queries } from './queries';

interface TransactionQueryResponse {
    transaction: {
        data: {
            contact: {
                identifier: string;
            };
        }
    }
};

interface PayTransactionViaCardResponse {
    payDebitViaCreditCard: {
        message: string;
        transaction: {
            identifier: string;
            states: { state: string }[];
            customerCreditCard: {
                brand: string;
                last4: string;
            };
            creditCardFee: number;
        };
    };

};


export class InternalTransactionsApiClient {

    constructor(private client: GraphQLClient) { }

    async getContact(transactionId: string) {
        const query = Queries.getTransaction;
        const variables = { transactionId: transactionId };
        const response = await this.client.request<TransactionQueryResponse>(query, variables);
        return response.transaction.data.contact;
    }

    async payTransactionViaCreditCard(transactionId: string, customerCreditCardId: string) {
        const query = Queries.payTransactionViaCard;
        const variables = { transactionId: transactionId, customerCreditCardId: customerCreditCardId };
        const response = await this.client.request<PayTransactionViaCardResponse>(query, variables);
        return response.payDebitViaCreditCard;
    }
}
